<template>
    <div>
        <div class="mb-1">
            <label class="form-label">{{componentType}}</label>
        </div>

        <div class="mb-1 d-flex align-items-center">
            <div class="me-2">Bg Color</div>
            <color-picker :color-object="component" color-field="background_color" class="mt-1"></color-picker>

            <div class="mx-2">Text</div>
            <color-picker :color-object="component" color-field="color" class="mt-1"></color-picker>
        </div>

    </div>
</template>

<script>
import ColorPicker from "../components/ColorPicker.vue";
export default {
    name: 'BgAndColorEditor',
    components: {ColorPicker},
    props: ['component', 'componentType'],
    data () {
        return {
            model: webase.model
        }
    },
    mounted() {
        console.log('BgAndColorEditor mounted')
    }
}
</script>

<style>

</style>
